import {
    GET_RESUMEN_DIRECTO,
    GET_MESES_DIRECTO,
    GET_PROVEEDORES_DIRECTO,
    GET_KPIS_GLOBALES_DIRECTO,
    SET_FILTROS_DIRECTO
} from '../types';


const estadoInicial = {
    resumen: null,
    queryResumen: null, // query (base64) con la que se cargó `resumen`; la usa la exportación de casos
    mesesDisponibles: [],
    proveedores: [],
    kpisGlobales: null,
    filtros: {
        responsableId: '',
        mes: '',
        fechadesde: '',
        fechahasta: '',
        criteriosFecha: ''
    }
};

export default function dashboardDirectoReducer(state = estadoInicial, action) {
    switch (action.type) {
        case GET_RESUMEN_DIRECTO:
            return {
                ...state,
                resumen: action.error ? null : action.payload,
                queryResumen: action.error ? null : (action.meta?.query ?? null)
            }
        case GET_MESES_DIRECTO:
            return { ...state, mesesDisponibles: action.error ? [] : (action.payload || []) }
        case GET_PROVEEDORES_DIRECTO:
            return { ...state, proveedores: action.error ? [] : (action.payload || []) }
        case GET_KPIS_GLOBALES_DIRECTO:
            return { ...state, kpisGlobales: action.error ? null : action.payload }
        case SET_FILTROS_DIRECTO:
            return { ...state, filtros: { ...state.filtros, ...action.payload } }
        default:
            return state
    }
}
